import EmptyStateCompany from "components/emptyState";
import TableContract from "components/table/tableContract";
import UseContext from "hooks/useContext";
import { useEffect, useState, useMemo } from "react";
import ApiDatabase from "server";
import Pagination from "components/pagination/pagination";
import { useOutletContext } from "react-router-dom";
import { dateWordShort } from "helper/helper";

const SignedContent = () => {
  const { companyData, refreshTime } = UseContext();
  const { searchValue = '', searchType = 'all' } = useOutletContext() || {};
  const titles = [
    "N° de contrat",
    "Intérimaire",
    "Mission",
    "N° De mission",
    "ÉTAT",
    "Date",
  ];
  const [arrayContracts, setArrayContracts] = useState([]);
  const [isWaiting, setIsWaiting] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const countPerPage = 25;

  useEffect(() => {
    if (Object.keys(companyData).length) {
      setIsWaiting(true);
      ApiDatabase.getContracts(
        { id: companyData._id, pStatus: 1 },
        (data) => {
          setArrayContracts(data);
          setIsWaiting(false);
          setCurrentPage(1);
        },
        (err) => {
          console.log(err);
          setIsWaiting(false);
        }
      );
    }
  }, [companyData._id, refreshTime]);

  // Fonction de filtrage selon le type de recherche
  const filterContracts = (contracts) => {
    if (!searchValue) return contracts;
    
    const searchLower = searchValue.toLowerCase();
    
    return contracts.filter(item => {
      switch (searchType) {
        case 'interimaire':
          const fullName = `${item?.userCollection[0]?.firstname || ''} ${item?.userCollection[0]?.lastname || ''}`.toLowerCase();
          return fullName.includes(searchLower);
        case 'contrat':
          const contractNumber = item?.contract_company[0]?.id_bestt?.toString().toLowerCase() || '';
          return contractNumber.includes(searchLower);
        case 'mission':
          const missionTitle = item?.title?.toLowerCase() || '';
          const missionId = item?.id_mission?.toString().toLowerCase() || '';
          return missionTitle.includes(searchLower) || missionId.includes(searchLower);
        case 'date':
          const contractDate = item?.contract_company[0]?.createdAt ? dateWordShort(item.contract_company[0].createdAt).toLowerCase() : '';
          return contractDate.includes(searchLower);
        case 'all':
        default:
          const allSearch = `${item?.contract_company[0]?.id_bestt || ''} ${item?.userCollection[0]?.firstname || ''} ${item?.userCollection[0]?.lastname || ''} ${item?.title || ''} ${item?.id_mission || ''} ${item?.contract_company[0]?.createdAt ? dateWordShort(item.contract_company[0].createdAt) : ''}`.toLowerCase();
          return allSearch.includes(searchLower);
      }
    });
  };

  const filteredContracts = useMemo(() => {
    return filterContracts(arrayContracts || []);
  }, [arrayContracts, searchValue, searchType]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchValue, searchType]);

  const countTotal = filteredContracts?.length || 0;
  const totalPages = Math.max(1, Math.ceil(countTotal / countPerPage));
  const paginatedContracts = (filteredContracts || []).slice(
    (currentPage - 1) * countPerPage,
    currentPage * countPerPage
  );

  return (
    <>
      <div>
        {isWaiting ? (
          <TableContract
            champsBody={[]}
            champsHeader={titles}
            isWaiting={true}
          />
        ) : (
          <>
            {filteredContracts.length ? (
              <TableContract champsBody={paginatedContracts} champsHeader={titles} isWaiting={false} />
            ) : (
              <EmptyStateCompany type={"contract"} />
            )}
          </>
        )}
      </div>
      {!isWaiting && filteredContracts.length > 0 && countTotal > countPerPage && (
        <div className="fixed bottom-0 left-0 right-0 border-t border-gray-100 bg-white px-8 py-4 z-50 tab:left-[80px] sidebar-expanded:left-64">
                  <Pagination
                    currentPage={currentPage}
                    countPerPage={countPerPage}
                    countTotal={countTotal}
                    totalPages={totalPages}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              )}
            </>
  );
};

export default SignedContent;
